import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'projects/extensions/src/environments/environment';
import { GoogleAuthenticatorService } from './google-authenticator.service';
import { MicrosoftAuthenticatorService } from './microsoft-authenticator.service';
import { TokenService } from './token.service';
import { IAuthenticator } from '@ext-interfaces/authenticator.model';

@NgModule({
    declarations: [],
    providers: [
        {
            provide: IAuthenticator,
            useClass: environment.extension === 'chrome' ? GoogleAuthenticatorService : MicrosoftAuthenticatorService
        },
        TokenService
    ],
    imports: [CommonModule]
})
export class AuthenticationModule {}
